import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans'
import DocSearchDefActions from './actionComponents/DocSearchDefActions'
import searchViewMap from "../Index";
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
const DocSearchHeader = (props) => {
    const { viewMap, viewData, enableDefault, 
            disableHeader, rowSelector, reloadSearch,
            deviceInfo} = props;

    const renderDefActions = () => {
        if (enableDefault) {
            //console.log("Import",viewData.childViews.compHeaderView);
            return (
                <DocSearchDefActions viewMap={viewMap} viewData={viewData.childViews.compHeaderView} 
                selectedDids={rowSelector.selectedRows}
                deviceInfo={deviceInfo}
                reloadSearch={reloadSearch} />
            )
        }
        else
            return null;
    }

    const renderSingleActionView = (actionView) => {
        let DynamicContainer = searchViewMap[actionView.viewKey];

        if (!DynamicContainer) {
            return null;
        }
        else {
            return (
                <DynamicContainer viewMap={viewMap} viewData={actionView} selectedDids={rowSelector.selectedRows}
                reloadSearch={reloadSearch} />
            )
        }
    }

    const renderActionView = () => {
        if (!enableDefault) return null;

        if (!viewData.childViews.actionView)
            return (null);

//        return null;

        // console.log("RenderReviewBatchAction",searchViewMap,viewData.childViews.actionView.viewKey)
        return (
            <>
                {Object.values(viewData.childViews.actionView.childViews).map((actionView, index) => (
                    renderSingleActionView(actionView)
                ))}
            </>
        )
    }

    if(disableHeader){
        return(
            null
        );
    }

    return (
        <div className="phViewHeading">
            <div className="phTitle">
                <span><SarasTrans value={`${viewData.masterKeys.docTypeName}`} /> <SarasTrans value="Search" /></span>
            </div>

            <div className="uiFlexDistributed uiFlexGap15" >
                <div className='uiFlexBox15 saras-tour-search-results-actions saras-tour-search-results-default-actions'>
                    {renderActionView()}
                    {renderDefActions()}
                </div>
            </div>
        </div>
    )
}

export default DocSearchHeader